import {AfterViewInit, Component, ElementRef, HostListener, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CroppingData} from '@rsp/shared/component/image-uploader/image-uploader.component';
import Cropper from 'cropperjs';

@Component({
  selector: 'rsp-cropper-dialog',
  templateUrl: './cropper-dialog.component.html',
  styleUrls: ['./cropper-dialog.component.scss']
})

export class CropperDialogComponent implements AfterViewInit {

  @ViewChild('image', {static: false}) public imageElement: ElementRef;
  private screenWidth: number;
  private screenHeight: number;
  private cropper: Cropper;

  constructor(public dialogRef: MatDialogRef<CropperDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: CroppingData) {
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    this.centerCropBox();
  }

  public onNoClick() {
    this.dialogRef.close();
  }

  public onYesClick() {
    const file: string = this.crop();
    this.dialogRef.close(file);
  }

  public ngAfterViewInit() {
    this.cropper = new Cropper(this.imageElement.nativeElement, this.cropperOptions());
  }

  public onZoom(ratio: number) {
    this.cropper.zoom(ratio);
  }

  private crop(): string {
    const canvas = this.cropper.getCroppedCanvas();
    return canvas.toDataURL(this.data.mimeType);
  }

  findScreenCenter(contWidth: number, contHeight: number, boxWidth: number, boxHeight: number): Cropper.SetCropBoxDataOptions {
    const wrapperCenterX = contWidth / 2;
    const wrapperCenterY = contHeight / 2;

    const cropCenterX = boxWidth / 2;
    const cropCenterY = boxHeight / 2;

    return {
      width: boxWidth,
      height: boxHeight,
      left: wrapperCenterX - cropCenterX,
      top: wrapperCenterY - cropCenterY,
    };

  }

  private centerCropBox() {
    const wrapperWidth: number = this.cropper.getContainerData().width;
    const wrapperHeight: number = this.cropper.getContainerData().height;
    this.cropper.setCropBoxData(this.findScreenCenter(wrapperWidth, wrapperHeight, this.data.width, this.data.height));
  }

  private cropperOptions(): Cropper.Options {
    const finalAspectRatio = this.data.width / this.data.height;
    const self = this;
    return {
      zoomable: true,
      scalable: false,
      responsive: true,
      dragMode: 'move',
      center: false,
      guides: false,
      highlight: false,
      viewMode: 0,
      autoCrop: true,
      cropBoxMovable: false,
      cropBoxResizable: false,
      toggleDragModeOnDblclick: false,
      zoomOnTouch: true,
      zoomOnWheel: true,
      aspectRatio: finalAspectRatio,
      ready() {
        self.centerCropBox();
      },
    };
  }
}
